import React, {useState} from "react";
import {useAuthContext} from "../common/context/authContext";
import {useQuery} from "@apollo/react-hooks";
import {useGraphqlLoadingComponent} from "../common/graphql";
import gql from "graphql-tag";
import ChangePasswordDialog from "./changePasswordDialog";
import Button from "../common/slds/buttons/button";
import {SldsInputField} from "../common/ui/form/formElements";
import {Form} from "../common/ui/form/formik";
import {Formik} from "formik";
import Page from "../common/ui/page";
import UserRolesField from "../components/user/UserRolesField";
import HorizontalList from "../common/slds/horizontalList/HorizontalList";
import {HorizontalListItem} from "../common/slds/horizontalList/HorizontalListItem";

const MyAccountPage = (props) => {
    let auth = useAuthContext();
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

    let userResult = useQuery(gql`
        query($id: ID!) {
            getUser(id: $id) {
                id
                login
                name
                email
                organisation {
                    id
                    name
                }
                roles
            }
        }
    `, {
        variables: {
            id: auth.userId()
        }
    });

    const loading = useGraphqlLoadingComponent(userResult);
    if (loading) {
        return loading;
    }

    let user = userResult.data.getUser;

    return <Page trail={[]}
                 title={`My Profile`}
                 info={<HorizontalList>
                     <HorizontalListItem>{user.name}</HorizontalListItem>
                     <HorizontalListItem>{user.email}</HorizontalListItem>
                 </HorizontalList>}
                 withPadding={true}>
        <Formik
            initialValues={
                {...user}
            }
            onSubmit={() => null}
            initialStatus={{
                readOnly: true,
                canEdit: false,
            }}
            enableReinitialize={true}
        >
            <Form>
                <SldsInputField name={"name"} label={"Full Name"}/>
                <SldsInputField name={"login"} label={"Login"}/>
                <SldsInputField name={"email"} label={"EMail"}/>
                <SldsInputField name={"organisation.name"} label={"Organisation"}/>
                <UserRolesField name={"roles"} label={"Roles"}/>
            </Form>

        </Formik>

        <div className="slds-m-top--small">
        <Button onClick={() => setShowChangePasswordModal(true)}>Change Password</Button>
        <ChangePasswordDialog userId={auth.userId()}
                              isOpen={showChangePasswordModal}
                              onRequestClose={() => setShowChangePasswordModal(false)}/>
        </div>
    </Page>;
};

export default MyAccountPage;